import { COST_CENTER_STATES } from "..";
import { apiInstance } from "../config/apiInstance";

export type CostCenterStateOption = {
  id: number;
  code: string;
  name: string;
};

export const getCostCenterStates = async (): Promise<
  CostCenterStateOption[]
> => {
  const response =
    await apiInstance.get<CostCenterStateOption[]>(COST_CENTER_STATES);
  return response.data;
};
